import { useState } from 'react';
import { useTranslate } from '../../../../../context/languageContext';
import { Collapse } from 'react-collapse';
import { R } from '../../../../../R';
import { stopInfoByStopId } from '../../../../../../redux/slices/markersSlice';
import { useSelector } from 'react-redux';
import { FaWheelchair } from "react-icons/fa";

export default function RouteDetailStopCol(props: any) {
  const t = useTranslate();
  const [opened, setOpened] = useState(false);

  const ArrowUp = R.drawables.general.Ic_ChevronUpSmall;
  const ArrowDown = R.drawables.general.Ic_ChevronDownSmall;
  const ExclamationIcon = R.drawables.commons.exclaimation;

  const stopHasAlert = (stop: any) => {
    return props.getAlertsForStop?.(stop)?.length > 0;
  };

  const hasAnyStopAlert = () => {
    return props.stops?.some((stop: any) => stopHasAlert(stop));
  };

  function StopRow({ stop }: any) {
    const rawStopId = stop?.stopCode;
    const stopId = stop?.stopId;
    const agencyOriginId = Number(stopId?.split(':')[0]);

    const stopInfo = useSelector(
      rawStopId && !Number.isNaN(agencyOriginId)
        ? stopInfoByStopId(rawStopId, agencyOriginId)
        : () => undefined
    );

    const hasAlert = stopHasAlert(stop);

    return (
      <div
        className="paddingVertical10"
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          minWidth: 0
        }}
      >
        <span style={{ flex: 1, minWidth: 0, paddingLeft: 20 }}>
          {stop?.name}
        </span>

        <div
          style={{
            minWidth: 48,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: 4
          }}
        >
          {hasAlert ? (
            <ExclamationIcon style={{ width: 16, height: 16 }} />
          ) : null}

          {stopInfo?.wheelchairBoarding && (
            <FaWheelchair size={16} color="gray" />
          )}
        </div>
      </div>
    );
  }

  const renderStops = () => {
    return props.stops.map((stop: any, index: number) => (
      <StopRow key={stop?.stopId ?? index} stop={stop} />
    ));
  };

  return props.stops?.length ? (
    <div
      className={'columnAlign pointer'}
      style={{ alignItems: 'initial', height: '100%' }}
      onClick={() => setOpened(!opened)}
    >
      <div className={'row'} style={{ width: '100%' }}>
        {opened ? <ArrowUp /> : <ArrowDown />}

        <div className={'secondaryText darkGray'}>
          {`${props.stops.length} ${props.stops.length === 1 ? t('stop') : t('stops_route')
            } ·`}
        </div>

        <div className={'secondaryText'}>
          {`${props.time} ${t('minutes')}`}
        </div>

        {hasAnyStopAlert() ? (
          <ExclamationIcon
            style={{
              width: 16,
              height: 16,
              marginLeft: 'auto'
            }}
          />
        ) : null}
      </div>

      <Collapse isOpened={opened}>
        <div style={{ width: '100%' }}>
          {renderStops()}
        </div>
      </Collapse>
    </div>
  ) : (
    <div className={'columnAlign pointer'} style={{ alignItems: 'initial', height: '100%' }}>
      <div className={'row'}>
        <div className={'secondaryText'}>
          {`${props.time} ${props.time > 1 ? t('minutes') : t('minute')}`}
        </div>
      </div>
    </div>
  );
}